import { PageContext } from "vike/types"
import { useServices } from "../../../composables/services";
import urlJoin from 'url-join';
import { useAuthControl } from "../../../composables/authControl";
import { useResultMessage } from "../../../composables/resultMessage";
import { resolveRoute } from 'vike/routing'

export async function data(pageContext: PageContext) {
  const { authControl, userState } = useAuthControl();
  const { resultMessage } = useResultMessage();
  const { routeParams } = resolveRoute('/roadtrips/@roadtripId', pageContext.urlPathname);

  const roadtripId = routeParams["roadtripId"];
  if (!roadtripId) { console.log('No roadtrip id.'); return; }

  await authControl.initialAuth;
  if (!userState.value.isSignedIn) { resultMessage.value = "Please sign in to view your road trips."; return; };

  const roadtrip = await getRoadtrip(roadtripId);

  return {
    title: roadtrip?.title || "An Epic Road Trip",
    description: roadtrip?.title || "An Epic Road Trip",
    canonicalUrl: pageContext.config.canonicalUrl ? urlJoin(pageContext.config.canonicalUrl, roadtripId) : undefined,
    roadtrip
  }
}

async function getRoadtrip(roadtripId: string) {
  const { roadtripsService } = useServices();
  const { resultMessage } = useResultMessage();

  try {
    resultMessage.value = undefined;

    const roadtrip = await roadtripsService.getRoadtrip(roadtripId);

    return roadtrip;
    
  } catch(e) {

    resultMessage.value = (e as Error).message;
  }

}